import Chip from '@mui/material/Chip';

import { RoleEnum } from '@/types/enums/role.enum';
import { t } from '@/utils/lang';

export interface StatusChipProps {
    status: RoleEnum;
    size?: 'small' | 'medium';
    showChip?: boolean;
    theme?: any;
}

const ChipRole = ({
    status,
    size = 'medium',
    showChip = true,
    theme,
}: StatusChipProps) => {
    let label: string;
    let color:
        | 'info'
        | 'warning'
        | 'success'
        | 'error'
        | 'default'
        | 'primary'
        | 'secondary';
    let colorHex: string;

    switch (status?.toLowerCase()) {
        case RoleEnum.ADMIN.toLowerCase():
        case 'new':
            label = 'Admin';
            color = 'primary';
            colorHex = theme?.palette.primary.main;
            break;

        case RoleEnum.CUSTOMER.toLowerCase():
        case 'on_time':
            label = 'Khách hàng';
            color = 'success';
            colorHex = theme?.palette.success.main;
            break;

        case RoleEnum.KTV.toLowerCase():
        case 'late_check_in':
            label = 'Kỹ thuật viên';
            color = 'info';
            colorHex = theme?.palette.info.main;
            break;

        default:
            label = 'Không xác định';
            color = 'default';
            colorHex = theme?.palette.text.primary;
    }

    if (showChip) {
        return (
            <Chip variant='tonal' label={t(label)} color={color} size={size} />
        );
    }

    return {
        label: t(label, 'RoleLabel'),
        color,
        colorHex,
    };
};

export default ChipRole;
